/* tslint:disable */
/* eslint-disable */
// PostgreSQL Search Queries for prosemirror-server

export const SEARCH_DOCUMENTS_POSTGRES = /* GraphQL */ `
  query SearchDocuments(
    $query: String!
    $workspaceId: ID
    $filters: SearchFilters
    $options: SearchOptions
  ) {
    searchDocuments(
      query: $query
      workspaceId: $workspaceId
      filters: $filters
      options: $options
    ) {
      items {
        id
        itemId
        workspaceId
        title
        snippet
        score
        similarity
      }
      totalCount
    }
  }
`;

export const VECTOR_SEARCH = /* GraphQL */ `
  query VectorSearch(
    $embedding: [Float!]!
    $workspaceId: ID
    $filters: SearchFilters
    $options: SearchOptions
  ) {
    vectorSearch(
      embedding: $embedding
      workspaceId: $workspaceId
      filters: $filters
      options: $options
    ) {
      items {
        id
        itemId
        workspaceId
        title
        snippet
        score
        similarity
      }
      totalCount
    }
  }
`;

export const HYBRID_SEARCH = /* GraphQL */ `
  query HybridSearch(
    $query: String!
    $embedding: [Float!]!
    $workspaceId: ID
    $filters: SearchFilters
    $options: SearchOptions
  ) {
    hybridSearch(
      query: $query
      embedding: $embedding
      workspaceId: $workspaceId
      filters: $filters
      options: $options
    ) {
      items {
        id
        itemId
        workspaceId
        title
        snippet
        score
        similarity
      }
      totalCount
    }
  }
`;


export const SEARCH_STATS = /* GraphQL */ `
  query SearchStats($workspaceId: ID!) {
    searchStats(workspaceId: $workspaceId) {
      totalDocuments
      documentsWithEmbeddings
      averageContentLength
    }
  }
`;

// Type definitions for the search responses
export interface SearchResult {
  id: string;
  itemId: string;
  workspaceId: string;
  title?: string;
  content: string;
  snippet?: string;
  score: number;
  similarity?: number;
}

export interface SearchResponse {
  items: SearchResult[];
  nextToken: string;
  totalCount: number;
}

export interface SearchFilters {
  trashed?: boolean;
  archived?: boolean;
  docType?: string;
}

export interface SearchOptions {
  limit?: number;
  offset?: number;
  textWeight?: number;
  vectorWeight?: number;
}

export interface SearchStats {
  totalDocuments: number;
  documentsWithEmbeddings: number;
  averageContentLength: number;
}
